module.exports = __webpack_public_path__ + "e0589f29ff39ab22e9d678dfba4e28c9.png";